var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawProfile1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 142 142",
    style: {
      enableBackground: "new 0 0 142 142"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E8E8EF;}\n\t.st1{fill:#C3C3D5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71,7.1c35.3,0,63.9,28.6,63.9,63.9s-28.6,63.9-63.9,63.9S7.1,106.3,7.1,71S35.7,7.1,71,7.1 C71,7.1,71,7.1,71,7.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22626_00000031199820338679215650000008836892790820788352_",
    className: "st1",
    d: "M72,30c17.7,0,32,14.1,32,31.5 S89.7,93,72,93S40,78.9,40,61.5S54.3,30,72,30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71,134.9c19.4,0,36.9-8.7,48.6-22.4c-3.7-5.7-10.2-9.5-17.6-9.5H41c-7.7,0-14.3,4.1-18,10.2 C34.7,126.5,51.9,134.9,71,134.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawProfile1);
export default __webpack_public_path__ + "static/media/undraw_profile_1.79cab4f9c497f4d2f92ffdea5683b7c6.svg";
export { ForwardRef as ReactComponent };